import {useUpdateEffect} from "../../../__snowpack__/pkg/ahooks.js";
import BraftEditor from "../../../__snowpack__/pkg/braft-editor.js";
import "../../../__snowpack__/pkg/braft-editor/dist/index.css";
import React, {useMemo, useState} from "../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../__snowpack__/pkg/react-intl.js";
import Preview from "./Preview.js";
import {RichTextEditorContext} from "./RichTextEditorContext.js";
import defaultUploadFn from "./utils/defaultUploadFn.js";
const languageMap = {
  zh: "zh",
  vn: "vi-vn"
};
const handleValue = (content) => {
  if (!content) {
    return null;
  }
  if (content?.[0] === "<") {
    return content?.replace(/[\n]/gms, "<br/>");
  }
  return `<p>${content?.replace(/[\n]/gms, "<br/>")}</p>`;
};
export default function RichTextEditor(props) {
  const {value, media, onBlur, id, wrapperStyle = {}, onChange, onSave, ...restProps} = props;
  const [editorState, setEditorState] = useState(BraftEditor.createEditorState(value));
  const {locale} = useIntl();
  useUpdateEffect(() => {
    if (value !== editorState.toHTML()) {
      setEditorState(BraftEditor.createEditorState(value));
    }
  }, [value]);
  const contextValues = useMemo(() => ({editorState}), [editorState]);
  return /* @__PURE__ */ React.createElement(RichTextEditorContext.Provider, {
    value: contextValues
  }, /* @__PURE__ */ React.createElement("div", {
    id,
    style: {...wrapperStyle}
  }, /* @__PURE__ */ React.createElement(BraftEditor, {
    language: languageMap[locale] ?? "en",
    ...props,
    value: editorState,
    media: {uploadFn: defaultUploadFn, ...media},
    onChange: (_editorState) => {
      setEditorState(_editorState);
      onChange?.(_editorState.toHTML());
    },
    onSave: () => {
      const htmlContent = editorState.toHTML();
      onChange?.(htmlContent === "<p></p>" ? void 0 : htmlContent);
    },
    onBlur: (e) => {
      const htmlContent = editorState.toHTML();
      onChange?.(htmlContent === "<p></p>" ? void 0 : htmlContent);
      onBlur?.(e);
    },
    ...restProps
  })));
}
RichTextEditor.Preview = Preview;
